module.exports = __webpack_public_path__ + "img/grooming6.ae88d1e1.jpg";